import { pacificWindow } from './time.js';
import { buildQueue } from './todo.js';
export const QUEUE_TABS = [['today', 'Today'], ['d14', '14 days'], ['all', 'All unopened']];
/** each tab's hover: which cases it holds */
export const QUEUE_TAB_HELP = { today: 'Cases converted today', d14: 'Cases converted in the last 14 days, today included',
    all: 'Every PLT / DEF record with no claim number on an open auto case, all time, oldest case first' };
/** the tab a page address asks for (?tab=d14), Today's cases when it names none; the old Older tab's address opens All unopened */
export function queueTabOf(v) {
    return v === 'd14' || v === 'all' ? v : v === 'older' ? 'all' : 'today';
}
const ms = (s) => Date.parse(String(s).replace(/\+0000$/, 'Z'));
/** which of the issues-list tabs a case belongs to: inside the 14-day window, or older (a case with no conversion time counts as older) */
export function issueTab(convertedAt, now) {
    return convertedAt && ms(convertedAt) >= ms(pacificWindow('issues', now).start) ? 'd14' : 'older';
}
export function splitIssues(issues, now) {
    const d14 = [];
    const older = [];
    for (const i of issues)
        (issueTab(i.matter.convertedAt, now) === 'd14' ? d14 : older).push(i);
    return { d14, older };
}
/** A group shows its first QUEUE_CAP rows, then "Show more (N)" (the working layout, Rod 2026-10-13 "2a": groups stay short so the first
 *  screen shows several kinds of work; Kimi's layout pass asked for 5 too; the longest wait of the whole group stays in its header). */
export const QUEUE_CAP = 5;
export function capGroup(g, open) {
    return open || g.items.length <= QUEUE_CAP ? { shown: g.items, more: 0 } : { shown: g.items.slice(0, QUEUE_CAP), more: g.items.length - QUEUE_CAP };
}
/** the oldest waitingSince in a group (its header's "longest wait") */
export function oldestWait(g) {
    let best = null;
    for (const it of g.items)
        if (!best || ms(it.row.waitingSince) < ms(best))
            best = it.row.waitingSince;
    return best;
}
export function ageTone(waitingSince, now) {
    const d = (now.getTime() - ms(waitingSince)) / 86_400_000;
    return d < 1 ? 'new' : d <= 3 ? 'late' : 'old';
}
/** The menu badge was the urgent rows (97); since Kimi's layout pass (2026-10-13) it is the client replies waiting (queueReplyCount): the group
 *  that comes first in every tab. The urgent count stays in the answer for the hover. */
export function queueUrgentCount(issues, now) {
    const q = buildQueue(issues, now);
    return q.groups.reduce((n, g) => n + g.items.filter((it) => it.urgent).length, 0);
}
export const sideKey = (side) => (side === 'PLT' ? 'PLT' : side === 'DEF' || side === 'Other Party' ? 'DEF' : null);
/** a Queue narrowed to the rows a filter keeps: empty groups drop out, every fold and the total follow */
export function filterTodo(q, keep) {
    const groups = q.groups.map((g) => ({ ...g, items: g.items.filter(keep) })).filter((g) => g.items.length);
    return { groups, working: q.working.filter(keep), parked: q.parked.filter(keep), fresh: q.fresh.filter(keep), total: groups.reduce((n, g) => n + g.items.length, 0) };
}
/** how many of a Queue's to-do rows are on each side (the Side buttons' counts) */
export function sideCounts(q) {
    const n = { PLT: 0, DEF: 0 };
    for (const g of q.groups)
        for (const it of g.items) {
            const k = sideKey(it.row.side);
            if (k)
                n[k]++;
        }
    return n;
}
/** The menu badge (Kimi's layout pass 2026-10-13): the client replies waiting for a person, the "answer these first" group, every tab. */
export function queueReplyCount(issues, now) {
    return buildQueue(issues, now).groups.find((g) => g.key === 'reply')?.items.length ?? 0;
}
/** The "After you save" line of a typed fact (Kimi's layout pass, T6): ONLY what is certain. The controller's person-facts stage runs on every
 *  watch run (claims-controller-watch, every 15 minutes) inside its window (lib/claims_controller/clock.js inWatchWindow: Monday to Saturday,
 *  7:00 am to 6:00 pm PT) with act.person_facts on: it re-reads the case live and writes the fact or marks it failed, and the row shows which.
 *  What follows a write (the letter, the next AI call) depends on other rules (an adjuster's email or fax, carrier hours, the call caps), so
 *  it is never promised here. api/test/after-save.test.ts checks these words against the controller's own clock and job schedule. */
export const AFTER_SAVE = 'After you save: the system checks it and writes it to the record on its next run (every 15 minutes, Monday to Saturday, 7 am to 6 pm PT); this row shows the result.';
//# sourceMappingURL=queue.js.map